import { downloadFile } from './globalFunctions';
import { changeModalState, showNotifyFail } from '../modules/actions';
import { Dispatch } from 'redux';
import { getTranslationKey } from '../modules/utils';

interface DownloadInvoiceOptions {
  url: string;
  dispatch: Dispatch;
}

/**
 * Downloads an invoice file with error handling.
 * Checks if the response is a JSON error (with null result) and shows error modal if needed.
 */
export const downloadInvoiceWithErrorCheck = async ({
  url,
  dispatch
}: DownloadInvoiceOptions): Promise<void> => {
  try {
    const response = await fetch(url);
    const contentType = response.headers.get('content-type');

    // Check if the response is JSON (error response) instead of a file
    if (contentType && contentType.includes('application/json')) {
      const data = await response.json();

      if (data.result === null) {
        dispatch(changeModalState({ key: 'invoiceDownloadErrorModal', state: true }));

        return;
      }
    }

    downloadFile(url);
  } catch (error: any) {
    // Only show error modal if we have internet connection
    if (navigator && navigator.onLine) {
      dispatch(changeModalState({ key: 'invoiceDownloadErrorModal', state: true }));
    } else {
      dispatch(showNotifyFail({ message: getTranslationKey('offlineMessage') }));
    }
  }
};
